module.exports = __webpack_public_path__ + "static/media/PendingUnitsIcon.d2286c6d.svg";